<template>
    <b-overlay :show="showoverlay" rounded="sm">
        <div class="card">
            <div class="card-body container">
             <table class="table table-borderless table-striped table-hover table-sm border-dark-custom"> 
                                    <thead>
                                        <tr style="background: rgba(128,128,128,0.2);">
                                            <th class="align-top border-dark-custom text-secondary py-3" colspan="7">Not completed({{incompleted_total}})</th>                        
                                        </tr>
                                    </thead>
                                    <tbody>
                                    <template v-if="wizard_data">
                                        <tr v-for="w_data in wizard_data" :key="w_data.id">
                                            <td><span class="float-left w-50">{{w_data.fiscal_year}}</span><span class="float-right text-left w-40">{{m_lists[w_data.month].text}}</span></td>
                                            <td></td>
                                            <td><b-button :variant="w_data.step_fiscal_year==1 ? 'outline-success': 'outline-danger'" @click="goToPayRuns(w_data.id,'fiscal_year')">Select Year- Month</b-button></td>
                                            <td><b-button :variant="w_data.step_joiner==1 ? 'outline-success': 'outline-danger'" @click="goToPayRuns(w_data.id,'joiner')">New Joiner</b-button></td>
                                            <td><b-button :variant="w_data.step_contract ==1 ? 'outline-success': 'outline-danger'" @click="goToPayRuns(w_data.id,'contract')">Contract changes</b-button></td>
                                            <td><b-button :variant="w_data.step_leaver ==1 ? 'outline-success': 'outline-danger'" @click="goToPayRuns(w_data.id,'leaver')">Leavers</b-button></td>
                                            <td><b-button :variant="w_data.step_payrun ==1 ? 'outline-success': 'outline-danger'" @click="goToPayRuns(w_data.id,'payrun')">Generate Payslips</b-button></td>
                                        </tr>
                                    </template>
                                    <template v-else>
                                    
                                    <tr>
                                            <td class="align-middle border-dark-custom text-secondary py-3" :colspan=7>No Incompleted Payruns</td>
                                    </tr>
                                    </template>
                                    </tbody>
                                </table>           
            </div> 
        </div>
    </b-overlay>
</template>
<style scoped>
button.disabled{cursor: default;}
</style>

<script>
    export default{
        props: [],        
        data(){
            return {
                
                company_name: '',
                m_lists : [{value: '1', text: 'January'},{value: '2', text: 'February'},{value: '3', text: 'March'},{value: '4', text: 'April'},{value: '5', text: 'May'},{value: '6', text: 'June'},{value: '7', text: 'July'},{value: '8', text: 'August'},{value: '9', text: 'September'},{value: '10', text: 'October'},{value: '11', text: 'November'},{value: '12', text: 'December'}],
                fdata: {
                        },
                
                showoverlay: false,
                incompleted_total: 0,
                wizard_data: [],  
            }
        },
        methods:{            
            getAcl: function()
            {
                axios.get(this.$api_url+'/acl' , {
                    params: {
                        url: this.cu
                    }
                }).then(function(response){
                    this.ce = response.data;                    
                }.bind(this));
            },
           getIncompletedPayRuns: function(){
            let currentObj = this;
            axios.get(this.$api_url+'/incompleted-payruns', {
                    params: {
                    }
                    })
              .then(function (response) {
                 this.showoverlay = false;
                 if(response.data.data){
                    this.incompleted_total = response.data.data.length;
                    this.wizard_data = response.data.data;
                 }
              }.bind(this)).catch(function (error){currentObj.serverError(error);});
            }, 
            goToPayRuns: function(wizard_id,step){
            let currentObj = this;
            let formData = new FormData();                
            formData.append('wizard_id', wizard_id);
            formData.append('step', step);
            
            axios.post(this.$api_url+'/payrun-step-save', formData)
                            .then(function (response) 
                            {                            
                                currentObj.successmsg = response.data.message;
                                if(response.data.success){
                                  window.location.href = this.$api_url+'/payroll/wizard';
                                }
                            }.bind(this)).catch(function (error){currentObj.serverError(error);});
            },
        },
        created: function(){
            this.getAcl();  
            this.getIncompletedPayRuns();
        },
        computed: 
        {

        }
    }
</script>
